"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formWrapper = _interopRequireDefault(require("../formWrapper.js"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy3"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _generateNewId = require("../../helpers/generateNewId");
var _settings = require("./Table/settings.js");
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _reducer = _interopRequireWildcard(require("./Table/reducer.js"));
var _reactRedux = require("react-redux");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _Preview = require("./Table/Preview");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _excluded = ["setFieldValue", "values"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Fortress = window.cccisd.fortress;
var Boilerplate = window.cccisd.boilerplate;
var appDefs = window.cccisd.appDefs;
var hasQuestProjectGroup = (0, _get2["default"])(appDefs, 'pawn.groups', []).some(function (group) {
  return group.handle === 'questproject';
});
var levelMap = {};
_settings.levelList.forEach(function (item) {
  levelMap[item.value] = item.label;
});
var rowsMap = {};
var _loop = function _loop() {
  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
    level = _Object$entries$_i[0],
    info = _Object$entries$_i[1];
  rowsMap[level] = {};
  info.rows.forEach(function (item) {
    rowsMap[level][item.value] = item.label;
  });
};
for (var _i = 0, _Object$entries = Object.entries(_settings.levels); _i < _Object$entries.length; _i++) {
  _loop();
}
var TablesForm = function TablesForm(props) {
  var Link = props.Link,
    settings = props.settings,
    updateSettings = props.updateSettings,
    options = props.options;
  var projectId = (0, _get2["default"])(options, 'customTables.projectId') || 0;
  var projects = (0, _reactRedux.useSelector)(function (state) {
    return state.tableEditor.projects;
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!projects && hasQuestProjectGroup) {
      _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              setLoading(true);
              _context.n = 1;
              return dispatch((0, _reducer.loadProjects)());
            case 1:
              setLoading(false);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }, []);
  var addTable = function addTable(values, closeModal) {
    var columns = function () {
      var levelInfo = appDefs.pawn[values.level].find(function (item) {
        return item.handle === values.rows;
      });
      if (levelInfo.importantFields && levelInfo.importantFields.length > 0) {
        var columnTree = (0, _settings.getFlatColumnTree)(values.level, values.rows);
        return levelInfo.importantFields.filter(function (field) {
          return field.path in columnTree;
        }).map(function (field, index) {
          return {
            id: index + 1,
            name: field.path,
            query: field.path,
            label: field.label,
            type: columnTree[field.path].type,
            alignment: 'left',
            filter: true,
            sort: true
          };
        });
      }
      return _settings.levels[values.level].initialColumns;
    }();
    updateSettings({
      list: [].concat(_toConsumableArray(settings.list || []), [{
        id: (0, _generateNewId.generateNewId)({
          prefix: 'table',
          settings: settings.list
        }),
        projectId: values.projectId,
        title: values.title,
        notes: values.notes,
        level: values.level,
        rows: values.rows,
        perPage: 50,
        showRowNumbers: false,
        useTaskMaster: false,
        columns: columns
      }])
    });
    closeModal();
  };
  var addTableValidate = function addTableValidate(values) {
    var errors = {};
    if (!values.title) {
      errors.title = 'Title is required';
    }
    return errors;
  };
  var duplicateTable = function duplicateTable(id) {
    var duplicatedTable = (0, _cloneDeep2["default"])(settings.list.find(function (item) {
      return item.id === id;
    }));
    updateSettings({
      list: [].concat(_toConsumableArray(settings.list), [_objectSpread(_objectSpread({}, duplicatedTable), {}, {
        id: (0, _generateNewId.generateNewId)({
          prefix: 'table',
          settings: settings.list
        })
      })])
    });
  };
  var deleteTable = function deleteTable(id) {
    updateSettings({
      list: settings.list.filter(function (item) {
        return item.id !== id;
      })
    });
  };
  var whitelistAllQueries = function whitelistAllQueries() {
    (0, _cccisdConfirm["default"])({
      message: 'Are you sure?'
    }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var errorCount, _iterator, _step, tableSettings, _t, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            setLoading(true);
            errorCount = 0;
            _iterator = _createForOfIteratorHelper(settings.list);
            _context2.p = 1;
            _iterator.s();
          case 2:
            if ((_step = _iterator.n()).done) {
              _context2.n = 7;
              break;
            }
            tableSettings = _step.value;
            _context2.p = 3;
            _context2.n = 4;
            return _cccisdAxios["default"].post(Boilerplate.route('graphql.whitelist'), {
              handle: "customTable_".concat(tableSettings.id),
              query: (0, _Preview.getQuery)(tableSettings),
              targetedPermissionGroupId: tableSettings.projectId || null
            });
          case 4:
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t = _context2.v;
            errorCount++;
          case 6:
            _context2.n = 2;
            break;
          case 7:
            _context2.n = 9;
            break;
          case 8:
            _context2.p = 8;
            _t2 = _context2.v;
            _iterator.e(_t2);
          case 9:
            _context2.p = 9;
            _iterator.f();
            return _context2.f(9);
          case 10:
            setLoading(false);
            (0, _cccisdNotification["default"])({
              message: /*#__PURE__*/_react["default"].createElement("div", null, "All queries have been whitelisted", /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  marginTop: '0.5em'
                }
              }, "Succeed: ".concat(settings.list.length - errorCount), /*#__PURE__*/_react["default"].createElement("br", null), "Failed: ".concat(errorCount)))
            });
          case 11:
            return _context2.a(2);
        }
      }, _callee2, null, [[3, 5], [1, 8, 9, 10]]);
    })));
  };
  var columns = [{
    name: 'actions',
    label: 'Actions',
    "class": 'text-center',
    render: function render(value, row) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-success btn-xs",
        onClick: function onClick() {
          return duplicateTable(row.id);
        }
      }, /*#__PURE__*/_react["default"].createElement(_copy["default"], null)), ' ', /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
        className: "btn btn-danger btn-xs",
        isConfirm: true,
        confirmationMessage: "Are you sure you want to delete table \"".concat(row.title, "\""),
        onClick: deleteTable.bind(null, row.id)
      }));
    }
  }, {
    name: 'title',
    label: 'Title',
    render: function render(value, row) {
      return /*#__PURE__*/_react["default"].createElement(Link, {
        path: "list[".concat(row.index, "]")
      }, value);
    },
    filter: true,
    sort: true
  }, {
    name: 'notes',
    label: 'Notes',
    filter: true,
    sort: true
  }, {
    name: 'level',
    label: 'Level',
    filter: true,
    sort: true
  }, {
    name: 'rows',
    label: 'Rows',
    filter: true,
    sort: true
  }, {
    name: 'projectTitle',
    label: 'Project',
    filter: true,
    sort: true
  }];
  var data = settings.list.map(function (item, index) {
    return {
      index: index,
      projectId: item.projectId,
      projectTitle: projects && projects[item.projectId] ? projects[item.projectId] : '-',
      id: item.id,
      title: item.title,
      notes: item.notes,
      level: levelMap[item.level],
      rows: rowsMap[item.level][item.rows]
    };
  }).filter(function (item) {
    return projectId ? item.projectId === projectId : true;
  });
  return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: loading
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "Tables"), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary"
    }, "Add Table"),
    title: "Add New Table",
    render: function render(_ref3) {
      var closeModal = _ref3.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: {
          projectId: projectId,
          title: '',
          notes: '',
          level: _settings.levelList[0].value,
          rows: _settings.levels[_settings.levelList[0].value].rows[0].value
        },
        onSubmit: function onSubmit(values) {
          return addTable(values, closeModal);
        },
        validate: addTableValidate,
        render: function render(_ref4) {
          var setFieldValue = _ref4.setFieldValue,
            values = _ref4.values,
            other = _objectWithoutProperties(_ref4, _excluded);
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "title",
            component: _cccisdFormik.CccisdInput,
            label: "Title",
            autoFocus: true
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "notes",
            component: _cccisdFormik.CccisdInput,
            label: "Notes"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "level",
            component: _cccisdFormik.CccisdSelect,
            label: "Level",
            options: _settings.levelList,
            style: {
              width: 'auto'
            },
            onChange: function onChange(event) {
              var value = event.target.value;
              setFieldValue('level', value);
              setFieldValue('rows', _settings.levels[value].rows[0].value);
            }
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "rows",
            component: _cccisdFormik.CccisdSelect,
            label: "Rows",
            options: _settings.levels[values.level].rows,
            style: {
              width: 'auto'
            }
          }), /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary",
            type: "submit"
          }, "Add Table"));
        }
      });
    }
  }), Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    style: {
      marginLeft: '0.5em'
    },
    className: "btn btn-primary",
    onClick: whitelistAllQueries
  }, "Whitelist all queries"), settings.list.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
    columns: columns,
    data: data,
    showPerPageOptions: false
  })));
};
var _default = exports["default"] = (0, _formWrapper["default"])()(TablesForm);
var store = window.cccisd && window.cccisd.store;
if (store) {
  if (!store.getState().tableEditor) {
    store.injectReducer('tableEditor', _reducer["default"]);
  }
} else if (process.env.NODE_ENV !== 'test') {
  console.error('There is no redux store at window.cccisd');
}